/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AuthRoute from './AuthRoute';

import NotificationPage from '../components/Pages/Notification';
import SettingsPage from '../components/Pages/Setting';
import CommunityPage from '../components/Pages/Community';
import CreateGroup from '../components/Pages/Community_UI/CreateGroup';
import CommunityGroupPage from '../components/Pages/Community_UI/Group';
import DiagnosisDetails from '../components/Pages/HealthRecord/HealthRecordDetails';
import HealthRecord from '../components/Pages/HealthRecord';
import Caregivers from '../components/Pages/CareGivers';
import LandingPage from '../components/Pages/LandingPage';
import ResponsiveDoctorList from '../components/Pages/ResponsiveDoctorList';
import ResponsiveDoctorDetail from '../components/Pages/ResponsiveHealthDetail';
import ResponsiveBookAppointment from '../components/Pages/ResponsiveBookAppointment';
import DoctorRating from '../components/Pages/RateDoctor';
import HospitalProfile from '../components/Pages/HospitalProfile';
import OtherHealthCareProvidersPage from '../components/Pages/OtherHealthCareProviders';

import DoctorEngagement from '../components/Pages/DoctorEngagement';
import CareGiverPage from '../components/Pages/CareGiverPage';
import BillingHistoryAccordion from '../components/Pages/Billing';
import BillingHistory from '../components/Pages/Billing';
import Appointment from '../components/Pages/Appointment';
import DoctorsEngagement from '../components/Pages/DoctorsEngagement';
import ProfilePage from '../components/Pages/profilePage';
import Chat from '../components/Pages/Chat';
import ConsultationSummary from '../components/Pages/ConsultationSummary';
import FundsManagement from '../components/Layout/FundsManagement';
import PharmacyPage from '../components/Pages/PharmacyPage';
import Pharmacy from '../components/Pages/pharmacy/Pharmacy';
import HospitalPage from '../components/Pages/HospitalPage';

import LaboratoryPage from '../components/Pages/LaboratoryPage';
import PatientDetailsNew from '../components/Pages/PatientDetailsNew';
import Patients from '../components/Pages/Patients';
import IVFConsultation from '../components/Patient/IVFConsultation';
import GeneralSurgery from '../components/Patient/GeneralSurgery';
import FamilyConsultationReadOnly from '../components/Patient/FamilyConsultationReadOnly';
import FamilyConsultation from '../components/Patient/FamilyConsultation';
import GeneralPractice from '../components/Patient/GeneralPracticee';
import Antinatal from '../components/Patient/Antinatal';
import Orthopedic from '../components/Patient/Orthopedic';
import Pediatrics from '../components/Patient/Pediatrics';
import CardiologyForm from '../components/Patient/CardiologyForm';
import AllOtherPractice from '../components/Patient/AllOtherPractice';
import Ophthalmologyy from '../components/Patient/Opthalmologyy';
import Career from '../components/Pages/career/Career';
import ProfilePages from '../components/Pages/career/CareerProfile';
import Lab from '../components/Pages/lab/Lab';
import MedicalDashboard from '../components/Pages/others/Others'
import PatientAdmissionDetails from '../components/Patient/PatientAdmissionDetails';
import AdvertManagement from '../components/Pages/AdvertManagement';
import ArticleDetails from '../components/Pages/ArticleDetails';
import BusinessCenter from '../components/Pages/BusinessCenter';
import EditBusinessCenter from '../components/Pages/EditBusinesCenter';
import GroupsPage from '../components/Pages/GroupsPage';
import SubmitFeedback from '../components/Pages/SubmitFeedback';
import AccountActivity from '../components/Pages/AccountActivity';
import ArticlePage from '../components/Pages/ArticlePage';
import Treatments from '../components/Patient/Treatments';
import ZoomPage from '../components/Patient/ZoomPage';
import NotFound from '../components/Pages/NotFound';
import MarketplacePage from '../components/Pages/MarketplacePage';
import BannedMedications from '../components/PharmacySearch/BannedMedications';
import Marketplace from '../components/Pages/MerchantMarketPlace/Marketplace';




const PortalRoutes = () => {
    return (
        <Routes>
            <Route path="/notifications" element={
                <AuthRoute>
                    <NotificationPage />
                </AuthRoute>
            } />
            <Route path="/settings" element={
                <AuthRoute>
                    <SettingsPage />
                </AuthRoute>
            } />
            <Route path="/community" element={
                <AuthRoute>
                    <CommunityPage />
                </AuthRoute>
            } />
            <Route path="/create-group" element={
                <AuthRoute>
                    <CreateGroup />
                </AuthRoute>
            } />
            <Route path="/adverts" element={
                <AuthRoute>
                    <AdvertManagement />
                </AuthRoute>
            } />
            <Route path="/articles/:id" element={
                <AuthRoute>
                    <ArticleDetails />
                </AuthRoute>
            } />
            <Route path="/group" element={
                <AuthRoute>
                    <CommunityGroupPage />
                </AuthRoute>
            } />
            <Route path="/health-record" element={
                <AuthRoute>
                    <HealthRecord />
                </AuthRoute>
            } />
            <Route path="/health-record/:id" element={
                <AuthRoute>
                    <DiagnosisDetails />
                </AuthRoute>
            } />
            <Route path="/facilities" element={
                <AuthRoute>
                    <Caregivers />
                </AuthRoute>
            } />
            <Route path="/landing" element={
                <AuthRoute>
                    <LandingPage />
                </AuthRoute>
            } />
            <Route path="/health-detail" element={
                <AuthRoute>
                    <ResponsiveDoctorDetail />
                </AuthRoute>
            } />
            <Route path="/business-center" element={
                <AuthRoute>
                    <BusinessCenter />
                </AuthRoute>
            } />
            <Route path="/groups-page" element={
                <AuthRoute>
                    <GroupsPage />
                </AuthRoute>
            } />
            <Route path="/business-center/:id" element={
                <AuthRoute>
                    <EditBusinessCenter />
                </AuthRoute>
            } />
            <Route path="/book-appointment" element={
                <AuthRoute>
                    <ResponsiveBookAppointment />
                </AuthRoute>
            } />
            <Route path="/doctor-rating" element={
                <AuthRoute>
                    <DoctorRating />
                </AuthRoute>
            } />
            <Route path="/doctors" element={
                <AuthRoute>
                    <DoctorEngagement />
                </AuthRoute>
            } />
            <Route path="/care-givers" element={
                <AuthRoute>
                    <CareGiverPage />
                </AuthRoute>
            } />
            <Route path="/billing-history" element={
                <AuthRoute>
                    <BillingHistory />
                </AuthRoute>
            } />
            <Route path="/appointments" element={
                <AuthRoute>
                    <Appointment />
                </AuthRoute>
            } />
            <Route path="/doctors-engagement" element={
                <AuthRoute>
                    <DoctorsEngagement />
                </AuthRoute>
            } />
            <Route path="/pharmacy-page" element={
                <AuthRoute>
                    <PharmacyPage />
                </AuthRoute>
            } />
            <Route path="/labs-page" element={
                <AuthRoute>
                    <LaboratoryPage />
                </AuthRoute>
            } />

            <Route path="/socials" element={
                <AuthRoute>
                    <ProfilePage />
                </AuthRoute>
            } />
            <Route path="/chat" element={
                <AuthRoute>
                    <Chat />
                </AuthRoute>
            } />
            <Route path="/consultation-summary" element={
                <AuthRoute>
                    <ConsultationSummary />
                </AuthRoute>
            } />
            <Route path="/billing" element={
                <AuthRoute>
                    <MedicalDashboard />
                </AuthRoute>
            } />
            <Route path="/pharmacy" element={
                <AuthRoute>
                    <Pharmacy />
                </AuthRoute>
            } />
            <Route path="/laboratory" element={
                <AuthRoute>
                    <Lab />
                </AuthRoute>
            } />
            <Route path="/patients/patient-details/:patientId" element={
                <AuthRoute>
                    <PatientDetailsNew />
                </AuthRoute>
            } />
            <Route path="/patients" element={
                <AuthRoute>
                    <Patients />
                </AuthRoute>
            } />
            <Route path="/admissions" element={
                <AuthRoute>
                    <Patients />
                </AuthRoute>
            } />
            <Route path="/hospitals" element={
                <AuthRoute>
                    <HospitalPage />
                </AuthRoute>
            } />
            <Route path="/other-providers" element={
                <AuthRoute>
                    <OtherHealthCareProvidersPage />
                </AuthRoute>
            } />
            <Route path="/patients/family-medcine/:patientId" element={
                <AuthRoute>
                    <FamilyConsultation />
                </AuthRoute>
            } />
            <Route path="/patients/family-medcine-treatment/:patientId" element={
                <AuthRoute>
                    <FamilyConsultationReadOnly />
                </AuthRoute>
            } />
            <Route path="/patients/IVF-consultation/:patientId" element={
                <AuthRoute>
                    <IVFConsultation />
                </AuthRoute>
            } />

            <Route path="/patients/general-surgery/:patientId" element={
                <AuthRoute>
                    <GeneralSurgery />
                </AuthRoute>
            } />
            <Route path="/patients/orthopedic-consultation/:patientId" element={
                <AuthRoute>
                    <Orthopedic />
                </AuthRoute>
            } />
            <Route path="/patients/general-practice/:patientId" element={
                <AuthRoute>
                    <GeneralPractice />
                </AuthRoute>
            } />
            <Route path="/patients/antinatal/:patientId" element={
                <AuthRoute>
                    <Antinatal />
                </AuthRoute>
            } />
            <Route path="/patients/pediatrics/:patientId" element={
                <AuthRoute>
                    <Pediatrics />
                </AuthRoute>
            } />
            <Route path="/patients/ophthalmology/:patientId" element={
                <AuthRoute>
                    <Ophthalmologyy />
                </AuthRoute>
            } />
            <Route path="/patients/cardiology/:patientId" element={
                <AuthRoute>
                    <CardiologyForm />
                </AuthRoute>
            } />
            <Route path="/patients/other-practices/:patientId" element={
                <AuthRoute>
                    <AllOtherPractice />
                </AuthRoute>
            } />
            <Route path="/profile" element={
                <AuthRoute>
                    <HospitalProfile />
                </AuthRoute>
            } />
            <Route path="/account-activities" element={
                <AuthRoute>
                    <AccountActivity />
                </AuthRoute>
            } />
            <Route path="/career" element={
                <AuthRoute>
                    <ProfilePages />
                </AuthRoute>
            } />
            <Route path="/patients/admission-details/:id" element={
                <AuthRoute>
                    <PatientAdmissionDetails
                        treatment={JSON.parse(localStorage.getItem("treatmentData"))}
                    />
                </AuthRoute>
            } />
            <Route path="/articles" element={
                <AuthRoute>
                    <ArticlePage />
                </AuthRoute>
            } />
            
            <Route path="/submit-feedback" element={<SubmitFeedback />} />
            
            {/* Marketplace routes */}
            <Route path="/marketplace/:category" element={
                <AuthRoute>
                    <MarketplacePage />
                </AuthRoute>
            } />
            <Route path="/marketplace/merchants" element={
                <AuthRoute>
                    <Marketplace />
                </AuthRoute>
            } />
            <Route path="/marketplace/banned-medications" element={
                <AuthRoute>
                    <BannedMedications />
                </AuthRoute>
            } />
            
            {/* Additional patient routes */}
            <Route path="/patients/treatments/:patientId" element={
                <AuthRoute>
                    <Treatments />
                </AuthRoute>
            } />
            
            <Route path="/appointments/meet/:id" element={
                <AuthRoute>
                    <ZoomPage />
                </AuthRoute>
            } />
            
            {/* Dashboard and main pages */}
            <Route path="/dashboard" element={
                <AuthRoute>
                    <MedicalDashboard />
                </AuthRoute>
            } />
            
            {/* Catch-all route - must be last */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default PortalRoutes;
